import {
  viewButterBarBasedOnUserPreference,
  closeButterBar,
} from "./butter-bar";

viewButterBarBasedOnUserPreference();

function windowResizeHandler() {
  // initPDNavigation();
  const btnHamburger = document.getElementById("btn-nav-hamburger");
  // TODO(Mark): Fix the hard coded value here. Taken from tailwind.config.app2.js md:breakpoint
  if (window.innerWidth > 959) {
    btnHamburger?.classList.contains("opened") ? toggleHamburger() : "";
  }
}

/**
 * This will get the height of the entire header (butterBar, nav) and create a spacer
 * underneath it to push content down. After creating a spacer it changes the nav
 * from relative to fixed. If there is a js error, nav will still work, it will
 * just be relative.
 */
export function initPDNavigation() {
  const navHolder = document.getElementById("pd-nav-holder");
  navHolder?.setAttribute("style", `height:${getHeaderHeight()}px`);
}

function getHeaderHeight() {
  const nav = document.getElementById("cband-navigation");
  return nav?.offsetHeight || 0;
}

const toggleHamburger = () => {
  const btnHamburger = document.getElementById("btn-nav-hamburger");
  btnHamburger?.classList.toggle("opened");
  btnHamburger?.setAttribute(
    "aria-expanded",
    btnHamburger?.classList.contains("opened") ? "true" : "false",
  );

  const mblNav = document.getElementById("mbl-nav");
  mblNav?.classList.toggle("hidden");
};

const btnHamburger = document.getElementById("btn-nav-hamburger");
if (btnHamburger) btnHamburger.addEventListener("click", toggleHamburger);

const toggleSearch = () => {
  const searchForm = document.getElementById("nav-search-form");
  const searchField = document.getElementById("nav-search-textfield");
  if (searchForm) {
    searchForm.classList.toggle("w-0");
    searchForm.classList.toggle("w-15gut");
    searchForm.classList.toggle("opacity-0");
    searchForm.parentElement?.classList.toggle("border-b");

    if (searchForm.classList.contains("w-15gut")) {
      searchField?.focus(); // Set focus on element open.
      searchField?.removeAttribute("tabindex"); // For accessibility keyboard tabbing.
    } else {
      searchField?.blur(); // Remove focus when closing search.
      searchField?.setAttribute("tabindex", "-1"); // For accessibility keyboard tabbing.
    }
  }
};

const btnNavigationSearch = document.getElementById("btn-search-toggle");
if (btnNavigationSearch)
  btnNavigationSearch.addEventListener("click", toggleSearch);

document
  .getElementById("btn-close-butter-bar")
  ?.addEventListener("click", () => closeButterBar());

window.addEventListener("resize", windowResizeHandler);
